export default __webpack_public_path__ + "static/media/kitchen5-beforeA-1024w.bb0bd7e5.webp";